// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"_1YvbT","withoutMenuButton":"_29NKH","logo":"_2ee_c","dev":"MpMXH","apiText":"aBqLZ"};